import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
// import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ExcelService } from '../../_services/excel.service';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {
  contracts: any;
  filterContracts: Array<object> = [];

  dtTrigger: Subject<any> = new Subject<any>();
  //dtOptions: DataTables.Settings = {};
  dtOptions: any = {};
  //dtOptions = {};
  
  loading: any;
  showCanceledContracts = false;

  role: any;
  producerId: any;


  constructor(private excelService:ExcelService, private authService: AuthenticationService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.loading = true
    this.role = this.authService.getUserRole();
    this.producerId = this.authService.getUserId();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      processing: true,
      dom: 'Bfrtip',
      buttons: [ 'excel', 'print' ],
      order: [[1, 'desc']],
      columnDefs: [
        { responsivePriority: 1, targets: -1 },
        { responsivePriority: 1, targets: -2 }
      ]
    };

    await this.getContracts();
    this.loading = false
  }

  async getContracts(){
    // this.loading = true;
    console.log('producerId', this.producerId);
    await this.authService.getAllContracts(this.producerId).then((res:any)=>{
      console.log('getAllContracts response', res);

      this.contracts = res[0];
      if (this.contracts) this.contracts = this.contracts.reverse()
      console.log('CONTRACTS ========>',this.contracts);


      this.loading = false;
    }, err=>{
      this.loading = false;
      console.log(err);
    })
  }

  showCanceled(event:any){
    console.log(event.target.checked);
    if(event.target.checked){
      this.showCanceledContracts = true;
      this.getContracts();
      //this.dtOptions.reload(); 

    }
  }

  ngAfterContentInit(){
    
  }

  contractDetails(contract:any){
    console.log('👉 ', this.contracts, '👈');
    this.router.navigate(['/contract-details/'], {
      state: { contract }
    });
  }

  exportAllAsXLSX():void {
    this.excelService.exportAsExcelFile(this.contracts, 'raw_contracts');
  }
  exportFilteredAsXLSX():void {
    // console.log(this.filterContracts);
    this.excelService.exportAsExcelFile(this.filterContracts, 'filtered_contracts');
  }

  onContractFileSelected(event: Event, contractId: string | number): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append('file', file as any);
    formData.append('contractId', contractId as any);
    console.log('👉👉👉👉👉👉👉 formData', JSON.stringify(formData), ' 👈👈👈👈👈👈👈');
    this.authService.uploadContract(formData)
      .then((res: any) => {
        console.log('Upload successful', res);
        alert('Upload successful');
        input.value = '';
        this.getContracts();
      })
      .catch((err: any) => {
        console.error('Upload error: ', err);
        alert(err.statusText)
        input.value = '';
      });
  }

}
